import React from 'react';

import { DocumentIcon } from '@cognite/cogs.js';

const InteractiveIcon = () => {
  return <DocumentIcon file="pdf" />;
};

export default InteractiveIcon;
